var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa-solid fa-circle-info fa-sm pointer",on:{"click":_vm.tip}})
}
var staticRenderFns = []

export { render, staticRenderFns }